import { Component, EventEmitter, Input,  Output, computed } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import _, { compact } from 'lodash';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import {  FormField, FormFieldTypes, ModelForFormContainer } from 'src/app/shared/forms/abstract-form-field.directive';
import { FormContainerVM, FormFieldValue } from 'src/app/shared/forms/form-vm-container.directive';

export type CheckBoxItem = {
  name: string,
  selected : boolean,
  value: string
}


@Component({
  selector: 'app-checkbox-button',
  templateUrl: './checkbox-button.component.html',
  styleUrls: ['./checkbox-button.component.scss']
})
export class CheckboxButtonComponent extends FormField<boolean> {

  readonly type : FormFieldTypes = 'check'

  @Input()
  set checked(v: boolean){
    this.model = v;
  };
  get checked(){
    return !!this.model;
  }

  @Input() override value: string | boolean = '';
  @Input() label: string = '';
  id: string = '';

  @Output() itemChanged = new EventEmitter<boolean>()

  readonly  fieldType = 'checkbox' ;

  controlSubscription?: Subscription

  static uid = 10;

  constructor() {
    super()
    CheckboxButtonComponent.uid += 1;
    if (this.name == '') {
      this.name = `${CheckboxButtonComponent.uid}`;
    }
    this.id = `${this.name}.${CheckboxButtonComponent.uid}`;
    // this.disabledManualBinding()
  }

   updateModel(formVM: FormContainerVM, value: FormFieldValue) {

     const sameNameCheckedItems = (formVM[this.name] ?? []) as string[] ;
     if (this._test) {
     }

    if (value) {
      return {
        ...formVM,
        [this.name] : _.uniq([...sameNameCheckedItems! , `${this.value}`])
      }
    }
    return {
      ...formVM,
      [this.name] : sameNameCheckedItems!.filter( i => i !== this.value )

    }
  }



  _onChange(event: boolean) {
    this.model = event
    this.itemChanged.emit(this.model)
  }

  _log(x?: any) {
    // this.control.patchValue(true)
  }

}
